import {typeExport} from "../../../../../redux/store/type";

const reducerIncreaseCreditSatiaScreen = (state = {
    failed: false,
    NoInternetDialog: false,
    result: [],
    showLoading: false
}, action) => {

    switch (action.type) {

        case typeExport.INCREASE_CREDIT_SERVICE_PENDING:
            return {
                ...state,

                NoInternetDialog: false,

                showLoading: true,

                failed: false,

                result: null


            };

        case typeExport.INCREASE_CREDIT_SERVICE_ERROR:

            return {
                ...state,

                NoInternetDialog: true,

                showLoading: false,

                failed: true,

            };

        case typeExport.INCREASE_CREDIT_SERVICE_SUCCESS:

            return {
                ...state,

                result: action.result,

                NoInternetDialog: false,

                showLoading: false,

                failed: false,

            };

        case typeExport.INCREASE_CREDIT_SERVICE_REFRESH:

            return {
                ...state,

                results: action.results,

                NoInternetDialog: false,

                isLoading: false,

            };

        default:

            return state;

    }

}


export default reducerIncreaseCreditSatiaScreen;
